import React from 'react';
import { createBrowserHistory } from 'history';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';

interface ReduxErrorState {
  globalError: boolean;
}

type GlobalErrorBoundaryProps = ReduxErrorState & WithTranslation;

interface GlobalErrorBoundaryState {
  error: unknown;
}

class GlobalErrorBoundary extends React.Component<
  GlobalErrorBoundaryProps,
  GlobalErrorBoundaryState
> {
  constructor(props: GlobalErrorBoundaryProps) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error: Error) {
    const isCacheError = error.toString().indexOf('ChunkLoadError') > -1;

    if (isCacheError) {
      this.retry();
    } else {
      this.setState({ error });
    }
  }

  retry = () => {
    const history = createBrowserHistory();
    history.go(0);
  };

  render() {
    const { children, globalError, t } = this.props;
    const { error } = this.state;

    if (globalError || error) {
      return (
        <section className="global-err center-align">
          <div className="global-err__content">
            <div>{t('Err_msg_default')}</div>
            <div className="center-align">
              <button
                className="btn btn--orange"
                onClick={this.retry}
                type="button"
              >
                {t('Retry')}
              </button>
            </div>
          </div>
        </section>
      );
    }

    return children;
  }
}

const mapStateToProps = (state: ReduxErrorState) => ({
  globalError: state.globalError
});

export default connect(mapStateToProps)(
  withTranslation()(GlobalErrorBoundary)
) as React.FC;
